export enum DeliveryNotAvailableAction {
	TAKE_AWAY,
	DECLINE
}
